import { Tooltip as ChakraTooltip, TooltipProps } from '@chakra-ui/react';

export const Tooltip = ({ children, label, isDisabled, ...props }: TooltipProps) => (
  <ChakraTooltip
    p={2}
    backgroundColor="neutral.595E6A"
    borderRadius="4px"
    fontSize="14px"
    label={label}
    isDisabled={isDisabled}
    placement="auto"
    {...props}
  >
    {children}
  </ChakraTooltip>
);
